/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterDataSimpleValueValueByMasterTypeGet } from '../fn/master-simple-value/api-master-data-simple-value-value-by-master-type-get';
import { ApiMasterDataSimpleValueValueByMasterTypeGet$Params } from '../fn/master-simple-value/api-master-data-simple-value-value-by-master-type-get';

@Injectable({ providedIn: 'root' })
export class MasterSimpleValueService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterDataSimpleValueValueByMasterTypeGet()` */
  static readonly ApiMasterDataSimpleValueValueByMasterTypeGetPath = '/api/MasterData/SimpleValue/ValueByMasterType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterDataSimpleValueValueByMasterTypeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterDataSimpleValueValueByMasterTypeGet$Response(params?: ApiMasterDataSimpleValueValueByMasterTypeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return apiMasterDataSimpleValueValueByMasterTypeGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterDataSimpleValueValueByMasterTypeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterDataSimpleValueValueByMasterTypeGet(params?: ApiMasterDataSimpleValueValueByMasterTypeGet$Params, context?: HttpContext): Observable<Array<string>> {
    return this.apiMasterDataSimpleValueValueByMasterTypeGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

}
